import React from 'react';
import { Modal, TFVButton } from '../../../Share/components';
import { isIE } from '../../../Share/utils';

function ErrorModal({
  isVisible = true,
  onClose = () => {},
  errorMessage = '',
  onClick = () => {},
}) {
  return (
    <Modal
      isVisible={isVisible}
      onCloseClicked={onClose}
      headerText="För många aktiva användare"
      className="tv-cancel-license__modal"
      headerClassName="tv-create-license__modal-header"
      ieOptionClassName={isIE ? 'ie-fix-height' : ''}
    >
      <p className="mb-3">{errorMessage}</p>
      <div className="justify-content-between tv-display-flex gap-4 tv-cancel-license__modal__footer mt-5">
        <TFVButton
          type="line-primary"
          buttonType="button"
          className="w-50"
          text="Avbryt"
          onClick={onClose}
        />
        <TFVButton
          type="secondary"
          buttonType="button"
          className="w-50"
          text="Till Användare"
          onClick={onClick}
        />
      </div>
    </Modal>
  );
}

export default ErrorModal;
